var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleUnfinished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.26875 2 2 8.26875 2 16C2 23.7312 8.26875 30 16 30C23.7312 30 30 23.7312 30 16C30 8.26875 23.7312 2 16 2ZM16 27.625C9.58125 27.625 4.375 22.4187 4.375 16C4.375 9.58125 9.58125 4.375 16 4.375C22.4187 4.375 27.625 9.58125 27.625 16C27.625 22.4187 22.4187 27.625 16 27.625Z",
    fill: "#BBF2CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.375C9.58125 4.375 4.375 9.58125 4.375 16C4.375 22.4187 9.58125 27.625 16 27.625C22.4187 27.625 27.625 22.4187 27.625 16C27.625 9.58125 22.4187 4.375 16 4.375ZM22.0438 11.4281L15.4625 20.5531C15.3705 20.6815 15.2493 20.7861 15.1088 20.8583C14.9683 20.9305 14.8126 20.9681 14.6547 20.9681C14.4968 20.9681 14.3411 20.9305 14.2006 20.8583C14.0601 20.7861 13.9389 20.6815 13.8469 20.5531L9.95312 15.1531C9.83438 14.9875 9.95312 14.7563 10.1562 14.7563H11.6219C11.9437 14.7563 12.2437 14.9125 12.4312 15.1719L14.6562 18.2594L19.5688 11.4469C19.7563 11.1844 20.0594 11.0312 20.3781 11.0312H21.8438C22.0469 11.0312 22.1656 11.2625 22.0438 11.4281V11.4281Z",
    fill: "#E5FAEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleUnfinished);
export default __webpack_public_path__ + "static/media/check-circle-unfinished.0c94e05c357d2f945a12ada726f70414.svg";
export { ForwardRef as ReactComponent };